import { render, staticRenderFns } from "./BoxEdit.vue?vue&type=template&id=425c000d&scoped=true&"
import script from "./BoxEdit.vue?vue&type=script&lang=js&"
export * from "./BoxEdit.vue?vue&type=script&lang=js&"
import style0 from "./BoxEdit.vue?vue&type=style&index=0&id=425c000d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425c000d",
  null
  
)

export default component.exports